import { render, staticRenderFns } from "./Factory-order-add.vue?vue&type=template&id=157e23e0&"
import script from "./Factory-order-add.vue?vue&type=script&lang=js&"
export * from "./Factory-order-add.vue?vue&type=script&lang=js&"
import style0 from "./Factory-order-add.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports